module.exports = __webpack_public_path__ + "../../static/img/melipixel.61b29f93.png";